export default __webpack_public_path__ + "static/spark_homepage-aa4df8c48c84d03c0037daac5ebc1164.png";